export const ENABLE_COUPONS = 'enable-landing-pages-coupons';
export const ENABLE_FUNDBOX_QUALIFIED_LIST_CONTROL = 'enable-fundbox-qualified-list-control';
export const ENABLE_HOLIDAY_BANNER = 'enable-holiday-banner';
export const ENABLE_ORPHAN_ACCOUNTS_REDIRECT = 'enable-orphan-accounts-redirect';
export const ENABLE_VELO_ASSISTANT = 'enable-velo-assistant';

export const RELEASE_BUSINESS_PROFILE_V2 = 'release-business-profile-v2';
export const RELEASE_BUSINESS_PROFILE_ASSISTANT = 'release-business-profile-assistant';
export const RELEASE_CONSTANT_CONTACT_PRODUCT_CARD = 'release-constant-contact-product-card';
export const RELEASE_FINANCE_HUB = 'release-finance-hub';
export const SHOW_DOWNLOAD_RECEIPTS = 'show-download-receipts';
export const RELEASE_COMPANIES_PAGE = 'release-companies-page';
export const ENABLE_AMENDMENT_V2_JOURNEY = 'enable-llc-amendment-v2-journey';
export const ENABLE_ANNUAL_REPORT_V2_JOURNEY = 'enable-llc-annual-report-v-2-journey';
export const ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES = 'enable-dashboard-link-to-manage-cookies';
